import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import axios from "axios";
import { ApiUrl } from '../Constants/Weburl'
import CustomContainer from './Customsettingscontain';
import CustomInput from './Custominput';
import CustomCard from './CustomCard';
import CustomPagination from './Custompagination';
import CommentsTable from './CommentsTable';

export default function PostDetails() {

    const [posts, setPost] = useState([]);

    const { id } = useParams();

    console.log("postId", id);


    useEffect(() => {
        fetchPostView()
    }, [id]);


    const fetchPostView = async () => {
        try {
        const token = localStorage.getItem("adminToken");

       

        const res = await axios.get(
            `${ApiUrl}api/auth/hashtag/post/${id}`,
            {
                headers: { Authorization: `Bearer ${token}` }
            }
        );

        console.log("res fetchpostview", res.data.post);

        setPost(res.data.post);
    } 
    catch (e) {
       console.log('error',e)
    }
}

 const getImageUrl = (img) => {
    if (!img) return "";
    if (img.startsWith("http")) return img;
    return `${ApiUrl}${img.replace("\\", "/")}`;
  };

  const getPostMedia = (filesStr) => {
  if (!filesStr) return [];
  try {
    const parsed = JSON.parse(filesStr);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};


    return (
        <CustomContainer className='allpostdetailshashtag'>
            {/* <CustomCard className="pv-card postdetails">

                <div className="pv-card-header">
                    <span>POST DETAILS</span>
                    <span className="tab">IMAGE</span>
                    <small>{new Date(posts.createdAt).toLocaleDateString("en-IN")}</small>
                </div>

                <div className="pv-user">
                    <div className="avatar">
                         <img
                                  src={getImageUrl(posts?.user?.avatar)}
                                  alt=""
                                  style={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: "50%",
                                  }}
                                />
                    </div>
                    <div>
                        <strong>{posts?.user?.username}</strong>
                        <p>{posts?.user?.name}</p>
                    </div>
                </div>

                <p className="hashtag">{posts?.description}</p>

                <div className="pv-stats">
                    <span><i className="bi bi-heart"></i>{posts?.like_posts?.length}</span>
                    <span><i className="bi bi-chat"></i>{posts?.comments?.length}</span>
                    <span><i className="bi bi-bookmark"></i>{posts?.save_posts?.length}</span>
                    <span><i className="bi bi-share"></i>{posts?.share_posts?.length}</span>
                </div>
            </CustomCard> */}

            <CustomCard className="pv-card postdetails">

  {/* Header */}
  <div className="post-content-header">

    <div className="post-content-title">
      <i className="bi bi-file-earmark-text-fill"></i>
      <strong>Post Details</strong>
    </div>

    <div className="post-content-date">
      <i className="bi bi-calendar3"></i>
      <span>
        {posts?.createdAt
          ? new Date(posts.createdAt).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
          : ""}
      </span>
    </div>

  </div>


  {/* User */}
  <div className="post-content-user">

    {/* <div className="post-user-info-wrapper"> */}
    <div className='profile-pill'>

      <div className="avatar">
        {posts?.user?.avatar ? (
          <img
            src={getImageUrl(posts.user.avatar)}
            alt=""
          />
        ) : (
          <span>
            {posts?.user?.username?.charAt(0)?.toUpperCase() || "U"}
          </span>
        )}
      </div>
      <div>

      <div className="username">

          {posts?.user?.username}
      </div>

      <div className='subtext'>

          @{posts?.user?.name || posts?.user?.username}

      </div>
      </div>

    </div>

    {/* <i className="bi bi-three-dots-vertical post-more"></i> */}

  </div>


  {/* Description */}
  <div className="post-description">
    {posts?.description}
  </div>

  {getPostMedia(posts?.files).length > 0 && (
  <div className="post-media">
    {getPostMedia(posts.files).map((file, idx) =>
      file.type?.startsWith("video") ? (
        <video
          key={idx}
          src={getImageUrl(file.uri)}
          controls
          className="post-media-item"
        />
      ) : (
        <img
          key={idx}
          src={getImageUrl(file.uri)}
          alt=""
          className="post-media-item"
        />
      )
    )}
  </div>
)}


  {/* Stats */}
  <div className="post-stats-row">

    <div className="post-stat">
         <div className="post-stat-top">
      <i className="bi bi-heart"></i>
        <strong>{posts?.like_posts?.length || 0}</strong>
        </div>
        <small>Likes</small>
    </div>

    <div className="post-stat">
        <div className="post-stat-top">
      <i className="bi bi-chat"></i>
      
        <strong>{posts?.comments?.length || 0}</strong>

          </div>
        <small>Comments</small>
    
    </div>

    <div className="post-stat">
        <div className="post-stat-top">
      <i className="bi bi-bookmark"></i>
      
        <strong>{posts?.save_posts?.length || 0}</strong>
         </div>
        <small>Bookmarks</small>

     
    </div>

    <div className="post-stat">
         <div className="post-stat-top">
      <i className="bi bi-share"></i>
     
        <strong>{posts?.share_posts?.length || 0}</strong>
        </div>
        <small>Shares</small>
      
    </div>

  
     
  
  </div>

  {/* <div className="post-bottom-waves">
  <div className="wave wave-1"></div>
  <div className="wave wave-2"></div>
</div> */}

 {/* <div className="post-bottom-waves">

  <svg
    className="post-wave-svg"
    viewBox="0 0 1440 180"
    preserveAspectRatio="none"
  >
    <path
      className="post-wave-back"
      d="
        M0,85
        C120,45 210,45 330,78
        C450,112 540,115 660,82
        C780,48 870,45 990,76
        C1110,107 1210,108 1320,75
        C1370,60 1410,65 1440,75
        L1440,180
        L0,180
        Z
      "
    />

    <path
      className="post-wave-front"
      d="
        M0,105
        C120,72 220,72 340,100
        C460,128 550,132 670,103
        C790,73 880,72 1000,100
        C1120,128 1210,130 1325,100
        C1375,87 1415,92 1440,98
        L1440,180
        L0,180
        Z
      "
    />
  </svg>

</div>  */}

</CustomCard>
        </CustomContainer>
    );
}
